import { render, staticRenderFns } from "./shangh.vue?vue&type=template&id=955b6198&"
import script from "./shangh.vue?vue&type=script&lang=js&"
export * from "./shangh.vue?vue&type=script&lang=js&"
import style0 from "./shangh.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports